var accentBar = {
  "accentBar": {
    "display": "block",
    "height": "0.25rem"
  }
};

export default accentBar;
